import { FunctionComponent, StrictMode } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import ContactUs from "./pages/website/ContactUs";
import LandingPage from "./pages/website";
import Prices from "./pages/website/B2BTiers";
import About from "./pages/website/About";
import Neatt from "./pages/website/Neatt";
import TrustedPartners from "./pages/website/TrustedPartners";
import AppWrapper from "./AppWrapper";
import AuthRoutes from "./routes/authRoutes";
import DashboardRoutes from "./routes/dashboardRoutes";
import TrustedPartnerApplication from "./pages/applications/TrustedPartnerApplication";
import ScheduleFollup from "./pages/dashboard/consultant/ScheduleFollowup";
import ResourceRoutes from "./routes/resourceRoutes";
import B2BTiers from "./pages/website/B2BTiers";
import B2CTiers from "./pages/website/B2CTiers";

const ClientVitals: FunctionComponent = () => (
  <AppWrapper>
    <Routes>
      {/* Website Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/enterprise-tiers" element={<B2BTiers />} />
      <Route path="/client-tiers" element={<B2CTiers />} />
      <Route path="/about" element={<About />} />
      <Route path="/neatt" element={<Neatt />} />
      <Route path="/trusted-partners" element={<TrustedPartners />} />
      <Route path="/apply-partner" element={<TrustedPartnerApplication />} />
      <Route path="/book-followup" element={<ScheduleFollup />} />

      <Route path="/auth/*" element={<AuthRoutes />} />
      <Route path="/dashboard/*" element={<DashboardRoutes />} />
      <Route path="/resources/*" element={<ResourceRoutes />} />

      {/* Catch all for now */}
      <Route
        path="*"
        element={
          <div className="p-8">
            <h1 className="text-3xl">Page Not Found</h1>
          </div>
        }
      />
    </Routes>
  </AppWrapper>
);

export default ClientVitals;
